// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { InstrumentSecurityControlServiceRequest } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/InstrumentSecurityControl';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useInstrumentSecurityControlServiceRequests: () => UseQueryResult<
  TemplateContract<InstrumentSecurityControlServiceRequest>[],
  string
> = () =>
  useOperatorBasedQuery(
    'queryInstrumentSecurityControlServiceRequests',
    (ledgerApi, offset, operator) =>
      ledgerApi.queryInstrumentSecurityControlServiceRequests(offset, operator),
  );

export default useInstrumentSecurityControlServiceRequests;
